// extracted by mini-css-extract-plugin
export default {"containerCharger":"EmptyList_containerCharger__ZTFGF","table":"EmptyList_table__vZhdM"};